const translations = {
    addExistingFlights: 'Add Existing Flights',
    addExistingFlightsCancel: 'Cancel',
    addExistingFlightsConfirm: 'Add',
    addExistingFlightsDateRangeSeparator: 'to',
    addExistingFlightsDroneFilterPlaceholder: 'Filter by drone',
    addExistingFlightsEmpty: 'No flights available to add.',
    addExistingFlightsError: 'Could not load flights. Try again.',
    addExistingFlightsLoading: 'Loading flights…',
    addExistingFlightsLoadingMore: 'Loading more flights…',
    addExistingFlightsSaving: 'Adding…',
    addExistingFlightsSelectAll: 'Select all',
    addExistingFlightsTimeFilterEnd: 'End hour:',
    addExistingFlightsTimeFilterStart: 'Start hour:',
    addExistingFlightsTitle: 'Add existing flights',
    addFlightToGroupCancel: 'Cancel',
    addFlightToGroupConfirm: 'Add',
    addFlightToGroupEmpty: 'No flight groups available.',
    addFlightToGroupPlaceholder: 'Select a flight group',
    addFlightToGroupSaving: 'Adding…',
    addFlightToGroupTitle: 'Add flight to group',
    addFlightToGroupTitleMany: 'Add {count} flights to group',
    addFlights: 'Add Flights',
    all: 'All',
    allDrones: 'All Drones',
    calendarLegend: 'Legend',
    calendarLegendFlightGroup: 'Flight group',
    chemicalLabel: 'Chemicals',
    contents: 'Contents',
    createMapButton: 'Create map',
    customerLabel: 'Customer',
    dateRangeSeparator: 'to',
    deleteFlightGroup: 'Delete flight group',
    deleteFlightGroupConfirm: 'Delete',
    deleteFlightGroupConfirmCancel: 'Cancel',
    deleteFlightGroupConfirmMessage: 'Are you sure you want to delete this flight group?',
    deleteFlightGroupConfirmTitle: 'Delete flight group?',
    deleteFlightsConfirm: 'Delete',
    deleteFlightsConfirmCancel: 'Cancel',
    deleteFlightsConfirmMessageMany: 'Are you sure you want to delete {count} flights?',
    deleteFlightsConfirmMessageOne: 'Are you sure you want to delete this flight?',
    deleteFlightsConfirmTitle: 'Delete flights?',
    deleteFlightsError: 'Failed to delete the selected flights. Please try again.',
    deleteFlightsErrorConfirm: 'OK',
    deleteFlightsErrorTitle: 'Delete failed',
    deleteFlightsSyncedError:
        'Synced flights cannot be deleted from AcreConnect. Remove any synced flights from your selection and try again.',
    deleteFlightsSyncedErrorConfirm: 'OK',
    deleteFlightsSyncedErrorTitle: 'Cannot delete synced flights',
    discardCancel: 'Keep editing',
    discardConfirm: 'Discard',
    discardMessage: 'You have unsaved changes in the new flight group. Discard them?',
    discardTitle: 'Discard changes?',
    downloadAsButton: 'Download',
    drawerSummaryFlights: 'Flights',
    drawerSummaryMaps: 'Maps',
    editFlightGroup: 'Edit',
    editFlightGroupCancel: 'Cancel',
    editFlightGroupConfirm: 'Save',
    editFlightGroupNamePlaceholder: 'Flight group name',
    editFlightGroupSaving: 'Saving…',
    editFlightGroupTitle: 'Rename flight group',
    fileTypeKml: 'KML',
    fileTypeSynced: 'Synced',
    flightLocationTitle: 'Location',
    flightRemoveAriaLabel: 'Remove flight from group',
    flightSourceCsv: 'CSV',
    flightSourceKml: 'KML',
    flightSourceSynced: 'Synced',
    flightTitlePrefix: 'Flight',
    flightTypeDry: 'Spread',
    flightTypeLiquid: 'Spray',
    flights: 'Flights',
    flightsCountSuffix: 'flights',
    groupButton: 'Group',
    groupCountOne: '{count} flight',
    groupCountOther: '{count} flights',
    inGroupLabel: 'In group:',
    listTabFlights: 'Flights',
    listTabGroups: 'Groups',
    logFlightsButton: 'Log Flights',
    manageConnections: 'Manage connections',
    mapApplicationDataAppliedRate: 'Estimated Applied Rate',
    mapApplicationDataAppliedTotal: 'Estimated Applied Total',
    mapApplicationDataAreaApplied: 'Estimated Area Applied',
    mapApplicationDataChemicalsApplied: 'Chemicals Applied',
    mapApplicationDataEndTime: 'End Time',
    mapApplicationDataLocation: 'Location',
    mapApplicationDataNa: 'N/A',
    mapApplicationDataStartTime: 'Start Time',
    mapApplicationDataTitle: 'Application Data',
    mapLegendTitle: 'Legend',
    mapRemoveAriaLabel: 'Delete map',
    mapTypeAam: 'Application Map',
    mapTypeAsFlown: 'As-Flown',
    mapTypeCoverage: 'Coverage',
    mapTypeDryCoverage: 'Dry Coverage',
    mapTypePillAam: 'AAM',
    mapTypePillAsFlown: 'As-Flown',
    mapTypePillCoverage: 'Covered',
    mapTypePillDryCoverage: 'Dry',
    mapTypePillSprayByArea: 'Spray',
    mapTypeSprayByArea: 'Spray by Area',
    maps: 'Maps',
    noFlightsEmpty: 'No flights',
    noGroupsEmpty: 'No groups',
    pageTitle: 'Flights & Maps',
    pilotLabel: 'Pilot',
    selectAllGroupFlightsAriaLabel: 'Select all flights in this flight group',
    selectAllInDateAriaLabel: 'Select all flights for this day',
    selectFlightAriaLabel: 'Select flight',
    selectionToolbarAddToGroup: 'Add to group',
    selectionToolbarDeleteAriaLabel: 'Delete selected flights',
    selectionToolbarSelectedCount: '{count} selected',
    shareToButton: 'Share',
    siteLabel: 'Site',
    statsFlightTime: 'Flight Time',
    statsFlights: 'Flights',
    statsGroups: 'Groups',
    statsMaps: 'Maps',
    totalLabel: 'total',
    ungroupedFlightsEmpty: 'All flights are in groups',
    ungroupedFlightsLoading: 'Loading flights…',
    ungroupedFlightsLoadingMore: 'Loading more flights…',
    uploadFlights: 'Upload Flights',
    viewCalendar: 'Calendar',
    viewMap: 'Map'
};

export default translations;
